const state = {
  loading: false,
};

const getters = {
  loading(state) {
    return state.loading;
  },
};

const mutations = {
  setLoading(state, payload) {
    state.loading = payload;
  },
};

const actions = {
  setLoading(context, payload) {
    context.commit('setLoading', payload);
  },
  reset(context) {
    context.commit('setLoading', false);
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
